import { darken, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mianDiv: {
    width: '90%',
    minWidth: 170,
    marginRight: '5%',
    height: '100%',
    borderWidth: 1,
    borderRightStyle: 'solid',
    borderColor: theme.palette.grey[300]
  },
  activeListItem: {
    borderRightWidth: 1,
    borderRightColor: theme.palette.primary.dark,
    borderRightStyle: 'solid',
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.45)
        : theme.palette.grey[300]
  }
}))
